(function () {
    'use strict';

    function requestForProposalContentController($scope, $timeout, $state, $rootScope,
        milestones, milestoneModalService, notifyService, requestForProposalStateService, toastr) {
        var vm = this;
        vm.rfpData = requestForProposalStateService.get();
        vm.rfpId = vm.rfpData.Id.split('/')[1];
        vm.canAdvance = false;
        vm.mode = 'Editor';
        vm.canDeleteInformationPart = true;
        vm.parentData = vm.rfpData;
        vm.modelOptions = {
            updateOn: 'default blur',
            debounce: {
                "default": 1000,
                "blur": 0
            }
        };

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.updateRfp = function (fieldName) {
            $timeout(function() {
                if (fieldName) {
                    notifyService.notify('You updated the ' + fieldName + 'for this RFP');
                }

                requestForProposalStateService.update(vm.rfpData);
            }, 0);
        }

        vm.toggleRfpContentReorderMode = function () {
            if (!$rootScope.rfpContentReorderMode) {
                $rootScope.rfpContentReorderModeToast = toastr.info('You are currently reordering the rfp content',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.rfpContentReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.rfpContentReorderModeToast) {
                    toastr.clear($rootScope.rfpContentReorderModeToast);
                    delete $rootScope.rfpContentReorderModeToast;
                }
            }

            $rootScope.rfpContentReorderMode = !$rootScope.rfpContentReorderMode;
        }

        vm.toggleRfpContentPreviewMode = function () {
            if (!$rootScope.rfpContentPreviewMode) {
                $rootScope.rfpContentPreviewModeToast = toastr.info('You are currently previewing the rfp content',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop previewing</button>",
                        onHidden: function () {
                            $rootScope.rfpContentPreviewMode = false;
                            vm.mode = 'Editor';
                        }
                    });
            } else {
                if ($rootScope.rfpContentPreviewModeToast) {
                    toastr.clear($rootScope.rfpContentPreviewModeToast);
                    delete $rootScope.rfpContentPreviewModeToast;
                }
            }

            $rootScope.rfpContentPreviewMode = !$rootScope.rfpContentPreviewMode;
            vm.mode = $rootScope.rfpContentPreviewMode ? 'Display' : 'Editor';
        }

        vm.updateDocumentPrompt = function (documentData) {
            requestForProposalStateService.updateDocumentPromptForRfpContent(documentData);
        }

        vm.deleteUpload = function (documentData, blobIndex) {
            requestForProposalStateService.deleteUploadForRfpContent(documentData, blobIndex);
        }

        vm.removeInformationPart = function (informationPart, partIndex) {
            requestForProposalStateService.removeInformationPartFromRfpContent(informationPart, partIndex);
        }

        vm.syncQuestionSet = function (questionSetData) {
            requestForProposalStateService.syncRfpContentQuestionSet(questionSetData);
        }

        vm.addingInformationPartType = '';
        vm.activateAddInformationPart = function (type) {
            vm.addingInformationPartType = type;
            vm.isAddingInformationPart = !vm.isAddingInformationPart;
        }

        vm.addInformationPart = function (informationPart) {
            requestForProposalStateService.addInformationPartToRfpContent(informationPart);
        }
    }

    requestForProposalContentController.$inject = ['$scope', '$timeout', '$state', '$rootScope',
        'milestones', 'milestoneModalService', 'notifyService', 'requestForProposalStateService', 'toastr'];

    angular.module('ecap.requestForProposal').controller('requestForProposalContentController', requestForProposalContentController);
})();
